import { createContext, useContext, type ReactNode } from 'react';
import type { Permission } from '@pz/core';
import type { ProcOutput } from '@pz/server';

export type Me = ProcOutput<'me.get'>;

const MeContext = createContext<Me | null>(null);

export function MeProvider({ me, children }: { me: Me; children: ReactNode }) {
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

export function useMe() {
  const me = useContext(MeContext);
  if (!me) throw new Error('useMe outside MeProvider');
  const perms = new Set(me.permissions as string[]);
  const leads = new Set(me.leadProjectIds);
  return {
    me,
    can: (...p: Permission[]) => p.some((x) => perms.has(x)),
    isLead: (projectId?: string) => (projectId ? leads.has(projectId) : leads.size > 0),
    personId: me.person.id,
  };
}
